import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { AlertModule } from '../shared/alert/alert.module';
import { DirectivesModule } from '../shared/directives/directives.module';
import { FileDownloadModule } from '../shared/file-download/file-download.module';
import { DownloadingService } from '../shared/file-download/service/downloading.service';
import { PrivateSignalRService } from '../wap/configuration/shared/services/private-signal-r.service';
import { SignalRService } from '../wap/configuration/shared/services/signalR.service';
import { CoreRoutingModule } from './core-routing.module';
import { CoreComponent } from './core.component';
import { HttpCancelInterceptor } from './interceptors/cancel.interceptor';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { MaintenanceModeAlertComponent } from './maintenance-mode/maintenance-mode-alert/maintenance-mode-alert.component';
import { MaintenanceModeComponent } from './maintenance-mode/maintenance-mode.component';
import { AuthService } from './services/auth.service';
import { HttpCancelService } from './services/cancel.service';
import { ManageErrorsService } from './services/manage-errors.service';
import { PolicyService } from './services/policy.service';
import { STORES } from './store/stores';

@NgModule({
  declarations: [CoreComponent, MaintenanceModeComponent, MaintenanceModeAlertComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    CoreRoutingModule,
    HttpClientModule,
    AlertModule,
    FileDownloadModule,
    DirectivesModule, // Remove if you don't use directives in this module
    DialogModule,
  ],
  exports: [RouterModule],
  providers: [
    PolicyService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCancelInterceptor,
      multi: true,
    },
    {
      provide: SignalRService,
      useClass: PrivateSignalRService,
    },
    HttpCancelService,
    DownloadingService,
    ManageErrorsService,
    ...STORES,
  ],
})
export class CoreModule {}
